// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"41c3e2c9","605":"b3560af5","809":"62452d41","981":"a77e2a73"}[chunkId] + ".chunk.js";
};